import ApplicationSerializer from 'teacher-ui-client/serializers/application'

/**
 * @class RolloverOwnerSerializer
 * @summary a Rollover is 'owned' by a teacher in the BE, this class was
 * created so that the Ember data store only contains teachers suitable for
 * display in the manage teachers page, not teachers that have been deleted
 * but are still associated with a rollover.
 */
export default class RolloverOwnerSerializer extends ApplicationSerializer {
  modelNameFromPayloadKey(key: string) {
    return super.modelNameFromPayloadKey(key === 'teachers' ? 'rollover-owner' : key)
  }

  payloadKeyFromModelName(modelName: string) {
    const adjustedName = modelName === 'rollover-owner' ? 'teachers' : modelName
    return super.payloadKeyFromModelName(adjustedName)
  }
}
